/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Body2Inputs */

const en_to_yaml_body2 = /** @type {(inputs: To_Yaml_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The output uses two space indentation, a 120 character line width, and no reference aliases, which matches the conventions of Kubernetes manifests and the major CI configuration formats. Arrays are written as block sequences with a dash per element rather than inline, because that is what people expect to read and edit in a config file.`)
};

const ko_to_yaml_body2 = /** @type {(inputs: To_Yaml_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출력은 2칸 들여쓰기, 120자 줄 너비, 참조 별칭 없음을 사용하며, 이는 Kubernetes 매니페스트와 주요 CI 설정 형식의 관례와 일치합니다. 배열은 인라인이 아니라 요소마다 대시를 붙인 블록 시퀀스로 작성됩니다. 설정 파일에서 사람들이 읽고 편집하기를 기대하는 형태이기 때문입니다.`)
};

const ja_to_yaml_body2 = /** @type {(inputs: To_Yaml_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力は 2 スペースインデント、120 文字の行幅、参照エイリアスなしを使い、これは Kubernetes マニフェストと主要な CI 設定形式の慣例に一致します。配列はインラインではなく、要素ごとにダッシュを付けたブロックシーケンスとして書かれます。設定ファイルで人が読み書きすると期待する形だからです。`)
};

/**
* | output |
* | --- |
* | "The output uses two space indentation, a 120 character line width, and no reference aliases, which matches the conventions of Kubernetes manifests and the ma..." |
*
* @param {To_Yaml_Body2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_body2 = /** @type {((inputs?: To_Yaml_Body2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Body2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_body2(inputs)
	if (locale === "ko") return ko_to_yaml_body2(inputs)
	return ja_to_yaml_body2(inputs)
});